import React from 'react';
import { CustomDialog } from '../CustomDialog';
import { useEvent } from '../../hooks/useEvent';

interface DialogDeleteEventProps {
  eventId: number; // event id to delete
  onSuccess: () => void;  // Callback to refresh events list after deletion
  onCancel: () => void; // Callback to close the dialog
}

export const DialogDeleteEvent: React.FC<DialogDeleteEventProps> = ({ eventId, onSuccess, onCancel }) => {
  const { handleDeleteEvent, updating } = useEvent();

  const handleDelete = async () => {
    const success = await handleDeleteEvent(eventId);
    if (success) {
      onSuccess();
    }
    onCancel();
  };

  return (
    <CustomDialog
      title="Are you sure you want to delete this event?"
      description="This action cannot be undone."
      primaryButtonText="Yes, delete"
      secondaryButtonText="Back"
      open={true}
      onClose={onCancel}
      onPrimaryButtonClick={handleDelete}
      onSecondaryButtonClick={onCancel}
      disablePrimaryButton={updating}
    />
  );
}; 